import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureToggleService } from 'src/app/core/services/application/feature-toggle.service';

@Directive({
    selector: '[cdpHideIfFeatureFlagOff]',
    standalone: false
})
export class HideIfFeatureFlagOffDirective implements OnInit {
    @Input('cdpHideIfFeatureFlagOff') featureName: string;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private featureFlagService: FeatureToggleService
    ) {}

    ngOnInit() {
        const featureFlag = this.featureFlagService.getFeatureFlagsByName(this.featureName);
        if (!featureFlag?.enabled) {
            this.viewContainer.clear();
        } else {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }
}
